import React, { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { motion } from "motion/react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "../../assets/styles/local/MaterialsSubList.css";
import bin from "../../assets/icons/Bin.svg";

import {
  FetchMaterialList,
  AddMaterialList,
  UpdateMaterialQuantity,
  DeleteMaterials,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { ADD_MATERIAL_LIST } from "../../redux/constants/type";

const MaterialsSubList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  console.log("asc56", location);
  const startingDate_Popup_Ref = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const projectid = window.localStorage.getItem("projectid");
  const projectcode = window.localStorage.getItem("projectcode");
  const firstname = window.localStorage.getItem("firstname");
  const isViewer = process.env.REACT_APP_IS_VIEWER;
  console.log("asc567", isViewer);

  const qtySubList = Number(location.state.qtySubList);
  const useList = Number(location.state.useList);

  const addMaterialListRes = useSelector(
    (state) => state.user.addMaterialListRes
  );

  const fetchMaterialListRes = useSelector(
    (state) => state.user.fetchMaterialListRes
  );

  const updateMaterialQuantityRes = useSelector(
    (state) => state.user.updateMaterialQuantityRes
  );

  const deleteMaterialsRes = useSelector(
    (state) => state.user.deleteMaterialsRes
  );

  const [materialsSubList, setMaterialsSubList] = useState([]);
  const [selectedBox, setSelectedBox] = useState([]);
  const [splitQty, setSplitQty] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [phaseName, setPhaseName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [total, setTotal] = useState("");
  const [unit, setUnit] = useState("");
  const [isOrderPick, setIsOrderPick] = useState(false);

  useEffect(() => {
    dispatch(FetchMaterialList(location.state.phaseID));
  }, []);

  useEffect(() => {
    if (fetchMaterialListRes.status === true) {
      setMaterialsSubList(fetchMaterialListRes.data[0].phaseMaterials);
      setFileName(fetchMaterialListRes.data[0].fileName);
      setFileSize(fetchMaterialListRes.data[0].fileSize);
      setPhaseName(fetchMaterialListRes.data[0].phaseName);
      setQuantity(fetchMaterialListRes.data[0].quantity);
      setTotal(fetchMaterialListRes.data[0].total);
      setUnit(fetchMaterialListRes.data[0].unit);
      setIsOrderPick(fetchMaterialListRes.data[0].isOrderPick);
      // setShowLoader(false);
    }
  }, [fetchMaterialListRes]);

  useEffect(() => {
    if (addMaterialListRes.status === true) {
      history.goBack();

      dispatch({
        type: ADD_MATERIAL_LIST,
        data: {},
      });
    }
  }, [addMaterialListRes]);

  // Data from AddMaterials screen👇.
  const [materialsSublistData, setMaterialsSublistData] = useState([]);
  useEffect(() => {
    if (location.state.materialsSublistData) {
      setMaterialsSublistData(location.state.materialsSublistData);
    }
  }, [location.state.materialsSublistData]);
  console.log("subMatData", materialsSublistData);

  // devide equal start👇.
  const [numberForDevide, setNumberForDevide] = useState(300); // NumberForDevide to be divided.
  const [subListCol, setSubListCol] = useState(qtySubList); // Number of subListCol.
  const [result, setResult] = useState([]); // Holds the divided parts.

  const sublistCount = result[0]?.map((_, index) => index + 1);
  console.log("asc56 result", result);

  // Function to divide the numberForDevide into equal parts.
  useEffect(() => {
    // let newResult = divideNumber(numberForDevide, subListCol);
    // setResult(newResult);

    if (location.state.materialsSublistData) {
      const materialQuantities = location.state.materialsSublistData.map((x) =>
        Number(x.quantity)
      );

      const newResult = divideNumber(materialQuantities, subListCol);
      setResult(newResult);
    }
  }, [numberForDevide, subListCol, location.state.materialsSublistData]);

  const divideNumber = (nums, cols) => {
    if (!nums || cols <= 0) return [];

    // Divide each number in the array
    return nums.map((num) => {
      const equalPart = Math.floor(num / cols);
      const remainder = num % cols;

      return Array(cols)
        .fill(equalPart)
        .map((value, index) => (index < remainder ? value + 1 : value));
    });
  };
  // devide equal end👆.

  const handleInputChange22 = (index, e) => {
    const { value, name } = e.target;
    const updatedResult = [...result];
    updatedResult[index][name] = value; // Update the value at the specific index.

    let workerUserID = updatedResult[index].id;
    let workerFirstName = updatedResult[index].firstName;
    let workerMaxAmount = updatedResult[index].maxAmount;
    console.log("asc56 workerUserID", workerUserID);

    setResult(updatedResult); // Update state.
    // dispatch(UpdateUserMaxAmount(workerUserID, workerMaxAmount));
  };

  const handleInputChange_useing_old = (outerIndex, e) => {
    const { value, name } = e.target;
    const updatedResult = [...result];

    // Update the specific value inside the nested array
    if (updatedResult[outerIndex]) {
      updatedResult[outerIndex] = updatedResult[outerIndex].map(
        (item, innerIndex) =>
          innerIndex === parseInt(name.split("-")[1], 10) ? Number(value) : item
      );
    }

    setResult(updatedResult);
  };

  const handleInputChange_pre = (outerIndex, e) => {
    const { value, name } = e.target;
    const updatedResult = [...result];
    const numericValue = Number(value); // Parse the input value as a number

    // Extract compareValue dynamically for the specific `outerIndex` and `innerIndex`
    const compareValue = location.state.materialsSublistData.map((x) =>
      Number(x.quantity)
    );
    const innerIndex = parseInt(name.split("-")[1], 10);

    // Validation: Prevent input greater than the specific `compareValue`
    if (numericValue > compareValue[innerIndex]) {
      alert(`Value cannot exceed ${compareValue[innerIndex]}`);
      return;
    }

    // Update the specific value inside the nested array
    if (updatedResult[outerIndex]) {
      updatedResult[outerIndex] = updatedResult[outerIndex].map((item, index) =>
        index === innerIndex ? numericValue : item
      );
    }

    setResult(updatedResult);
  };

  ////////////////////////////////////////
  const handleInputChange = (outerIndex, e) => {
    const { value, name } = e.target;
    const updatedResult = [...result];
    const numericValue = Number(value);

    // Extract the column index (innerIndex) from input name
    const innerIndex = parseInt(name.split("-")[1], 10);

    // Validation: Prevent exceeding the original quantity
    const originalQty =
      materialsSublistData[outerIndex].originalQuantity ||
      materialsSublistData[outerIndex].quantity;
    const currentDistributedSum =
      updatedResult[outerIndex]?.reduce((sum, val) => sum + (val || 0), 0) -
      (updatedResult[outerIndex][innerIndex] || 0);

    if (numericValue + currentDistributedSum > originalQty) {
      alert(
        `Value cannot exceed the remaining quantity: ${
          originalQty - currentDistributedSum
        }`
      );
      return;
    }

    // Update the input value in result
    updatedResult[outerIndex][innerIndex] = numericValue;

    // Calculate remaining quantity
    const remainingQty =
      originalQty -
      updatedResult[outerIndex].reduce((sum, val) => sum + (val || 0), 0);

    // Update materialsSublistData
    const updatedMaterialsSublistData = [...materialsSublistData];
    updatedMaterialsSublistData[outerIndex] = {
      ...updatedMaterialsSublistData[outerIndex],
      quantity: remainingQty,
      originalQuantity: originalQty, // Store original quantity
    };

    // Update states
    setResult(updatedResult);
    setMaterialsSublistData(updatedMaterialsSublistData);
  };

  const calculateRemainingQty = (originalQty, distributedValues) => {
    return (
      originalQty - distributedValues.reduce((sum, val) => sum + (val || 0), 0)
    );
  };

  const calculateKgTotal = (kg, qty) => {
    return (kg || 0) * (qty || 0);
  };
  ///////////////////////////////////////////////////

  // Calculate subtotal for a specific result[index]
  const calculateSubtotal = (index) => {
    if (!result[index]) return 0;
    return result.flat().reduce((sum, current) => sum + current, 0);
  };

  // Calculate column-wise totals.
  const columnWiseTotal = result[0]?.map((_, colIndex) => {
    return result.reduce((sum, row) => {
      // If the column index exists in the row, add the value to the sum.
      return sum + (row[colIndex] || 0);
    }, 0);
  });

  let apiDispatchData = materialsSublistData.map((item) => ({
    asc_MaterialID: item.materialId,
    asc_MaterialUnit: item.unit,
    asc_MaterialQty: item.quantity,
  }));

  return (
    <div>
      <div className="py-3 ps-5 d-none">
        <input
          type="number"
          value={numberForDevide}
          placeholder=""
          onChange={(e) => setNumberForDevide(Number(e.target.value))}
        />

        <input
          type="number"
          value={subListCol}
          onChange={(e) => setSubListCol(Number(e.target.value))}
        />
      </div>

      <div className="d-flex flex-wrap justify-content-between pt-5 px-5">
        <div className="d-flex flex-wrap">
          <p className="sublist">Create Sublists｜</p>
          <p className="sublist22">{location.state.selectedSplit}</p>
        </div>

        <div className="d-flex gap-3">
          <button
            className="cancelBtn"
            onClick={() => {
              history.goBack();
            }}
          >
            <p className="mb-0">Cancel</p>
          </button>

          <button
            className="addBtn"
            onClick={() => {
              if (location.state.subListAlredayCreated) {
                let materialQuantities = materialsSublistData.map(
                  (x, index) => ({
                    materialQuantityidhh: x.materialId,
                    unit: x.unit,
                    quantity: x.quantity,
                  })
                );
                dispatch(UpdateMaterialQuantity(materialQuantities));
              } else {
                let resultSplitQty = result.map((item) => item);
                let materialQuantities = materialsSublistData.map(
                  (x, index) => ({
                    materialid: x.materialId,
                    unit: x.unit,
                    // quantity: x.quantity,
                    quantity: resultSplitQty[index],
                  })
                );

                // new payload
                let _payload = [];

                materialQuantities.forEach((element) => {
                  if (element.quantity.length > 0) {
                    element.quantity.forEach((qty) => {
                      _payload.push({
                        materialid: element.materialid,
                        unit: element.unit,
                        quantity: qty,
                      });
                    });
                  } else {
                    _payload.push({
                      materialid: element.materialid,
                      unit: element.unit,
                      quantity: 0,
                    });
                  }
                });
                dispatch(AddMaterialList(_payload));
              }
            }}
          >
            <p className="mb-0">
              {location.state.subListAlredayCreated ? "Update" : "Add"}
            </p>
          </button>
        </div>
      </div>

      <div id="ascSelectBox" className="ascTableWrapper tableHt px-4 pt-2 mt-3">
        <table className="material-table tabl-e w-100 h-100">
          <thead>
            <tr>
              <th className="fw-bold" style={{ width: "10%" }}>
                {phaseName}
              </th>
              <th style={{ width: "25%" }}></th>
              <th></th>
              <th className="fw-bold">{quantity}</th>
              <th style={{ width: "10%" }}>
                <div className="d-flex gap-3">
                  {/* {result[0]?.map((item, index) => (
                    <th
                      className="mb-0 text-center subListColBorder"
                      style={{ width: "109px" }}
                    >
                      {calculateSubtotal(item) || "0"}
                    </th>
                  ))} */}

                  {columnWiseTotal?.map((total, index) => (
                    <th
                      key={index}
                      className="mb-0 text-center subListColBorder"
                      style={{ width: "118px" }}
                    >
                      {total || "0"}
                    </th>
                  ))}
                </div>
              </th>
              <th className="fw-bold">{total}</th>
              <th className="align-middle"></th>
            </tr>

            <tr>
              <th style={{ width: "10%" }}>Art.No.</th>
              <th style={{ width: "25%" }}>Material</th>
              <th>Kg</th>
              <th style={{ width: "9%" }}>
                <div className="mb-0 d-flex gap-3">
                  <span>
                    Qty <span className="ps-4"> Tot.Kg</span>
                  </span>
                </div>
              </th>
              <th>
                <div className="d-flex gap-3">
                  {result[0]?.map((item, index) => (
                    <th
                      className="mb-0 subListColBorder"
                      style={{ minWidth: "15%" }}
                    >
                      <span>
                        Qty <span className="ps-4"> Tot.Kg</span>
                      </span>
                    </th>
                  ))}
                </div>
              </th>
              <th>Total</th>
              <th>
                Remove item
                <img
                  src={bin}
                  alt=""
                  className="ms-3 pointer"
                  style={{ width: "16px" }}
                  onClick={() => {
                    let material = selectedBox.map((x) => ({
                      materialid: x.asc_BoxID,
                    }));
                    dispatch(DeleteMaterials(material));
                    // Delete multiple items from List like splice.
                    // let data = new Array();
                    // materialsSublistData.map((item) => {
                    //   console.log("ase44", materialsSublistData);
                    //   if (
                    //     !material.find((x) => x.materialid === item.materialId)
                    //   ) {
                    //     data.push(item);
                    //   }
                    // });
                    // setMaterialsSublistData(data);
                  }}
                />
              </th>
            </tr>

            <tr className="nestedBG">
              <th className="fw-bold" style={{ width: "10%" }}>
                Lists
              </th>
              <th style={{ width: "25%" }}></th>
              <th></th>
              <th></th>
              <th className="d-flex justify-content-around fw-bold">
                {sublistCount?.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
              </th>
              <th className="align-middle"></th>
              <th className=""></th>
            </tr>
          </thead>
          <tbody>
            {materialsSublistData.map((item, index) => {
              const remainingQty = calculateRemainingQty(
                item.originalQuantity || item.quantity,
                result[index] || []
              );

              const kgTotal = calculateKgTotal(item.unit, remainingQty);

              return (
                <tr key={item.materialId}>
                  <td>{item.articalNumber || "—"}</td>
                  <td
                    title={
                      item?.materialName?.length > 30 && item?.materialName
                    }
                    style={{
                      // for 3 dots 👇
                      // whiteSpace: "pre-wrap",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "10px",
                    }}
                  >
                    {item.materialName || "—"}
                  </td>

                  <td>{item.unit || "—"}</td>

                  <td>
                    <div className="d-flex gap-5 justify-content-start">
                      {/* {item.quantity || "—"} */}
                      <span className="ps-2 fw-bold text-black">
                        {remainingQty}
                      </span>

                      <span className="ps-">
                        {Math.round(item.unit * remainingQty)}
                      </span>
                    </div>
                  </td>

                  {/* Dynamic start */}
                  <td className="d-flex gap-3 justify-content-aroun-d justify-content-start">
                    {/* {result.map((x, index) => {
                    console.log("asc45", x);
                    return (
                      <td key={index} style={{ width: "100px" }}>
                        <input
                          readOnly={location.state.selectedSplit !== "Custom"}
                          type="number"
                          className="sublistInput"
                          value={x.asc_Quantity}
                          placeholder=""
                          name="asc_Quantity"
                          onChange={(e) => handleInputChange(index, e)}
                        />
                      </td>
                    );
                  })} */}

                    {result[index] &&
                      result[index].map((qty, innerIndex) => (
                        <div className="d-flex gap-4 borderRightMat">
                          <div className="">
                            <input
                              key={index}
                              readOnly={
                                location.state.selectedSplit !== "Custom"
                              }
                              type="number"
                              className="sublistInput ps-3 bg-transparent"
                              value={qty} // Ensure `qty` exists
                              placeholder=""
                              name={`asc_Quantity-${innerIndex}`}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <span className="">
                              {Math.round(item.unit * qty)}
                            </span>
                          </div>
                        </div>
                      ))}
                  </td>
                  {/* Dynamic end */}

                  <td className="ps-3">{item.total || "—"}</td>

                  {/* <td className="ps-5">{item.isDelete === 0 ? "No" : "—"}</td> */}
                  <td>
                    <div className="ps-5">
                      <label className="asc-label-top projectNameText d-none">
                        Need PO ?
                      </label>
                      <div className="ps-2 assign_Probability_project gap-3">
                        <div className="d-flex align-items-center gap-1 assignment_radio">
                          <input
                            type="checkbox"
                            className="form-check-input pointer companyRadio"
                            // checked={deleted === true}
                            // checked={selectedId === x.materialId}
                            checked={selectedBox.find(
                              (x) => x?.asc_BoxID === item.materialId
                            )}
                            style={{
                              fontSize: "12px",
                              width: "15px",
                              height: "15px",
                              border: "1px solid",
                              borderRadius: "3px",
                            }}
                            // value={isDeleted}
                            onChange={(e) => {
                              // setDeleted(e.target.checked);
                              // setDeleted(true);
                              // setSelectedId(x.materialId);
                            }}
                            onClick={() => {
                              let index2 = selectedBox.findIndex(
                                (x) => x?.asc_BoxID === item.materialId
                              );

                              if (index2 !== -1) {
                                let data = [...selectedBox];
                                data.splice(index2, 1);
                                setSelectedBox(data);
                                return;
                              }

                              // start item pushing...
                              let invoiceListArray = [...selectedBox];
                              invoiceListArray.push({
                                asc_BoxName: item.materialName,
                                asc_BoxID: item.materialId,
                              });
                              setSelectedBox(invoiceListArray);
                            }}
                          />
                          {/* Yes */}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
            {materialsSublistData.length === 0 && (
              <span className="noDataDisplay">
                No data to display!
                {/* {FetchTranslationList?.data?.data[94]?.translation} */}
              </span>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MaterialsSubList;
